import React from "react";
import { Theme } from "./model";

export const ThemeContext = React.createContext(Theme.light);
